import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { CATALOGS, RESOURCE_LEVEL, RESOURCES } from "../../../constants/route-paths";
import {
  addLevel,
  updateLevel,
  getLaborList as getLaborListAPI,
  getLevel as getLevelAPI,
} from "./../../../actions/inventory.action";
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Form from 'react-bootstrap/Form'
import CustomInput, { AmountInput, LockInput } from "../../../components/inputs/new-input";
import TextAreaInput from "../../../components/inputs/textarea-input";
import { levelFields } from "./data/level-fields";
import _ from 'lodash';
import { toPercent, toUSD } from "../../../util/currency-formatter";
import { toDecimal } from "../../../util/decimal-utils";
import idx from 'idx';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { ValidateField, ValidatorTypes } from "../../../util/validators";
import { useMatch, useNavigate, useParams } from "react-router";

export default function AddLevel({ writePermission, ...props }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { levelId } = useParams();
  const match = useMatch(`/${CATALOGS}/${RESOURCE_LEVEL}/edit/${levelId}`);
  const [fields, setFields] = useState(_.cloneDeep(levelFields))
  const [state, setState] = useState({
    levelId: null,
    edit: false,
    costObj: {
      laborId: "",
      skill: "",
      hourlyCost: "",
      averageCost: "",
      averageCostLock: true,
      type: "amount",
      selected: "",
      label: "Unit Cost",
      touched: false,
      valid: true,
      error: false,
    },
    labors: [],
  })

  useEffect(() => {
    getLaborList();
  }, [])

  const getLevel = () => {
    if (match && levelId) {
      dispatch(getLevelAPI(levelId, true)).then((labor) => {
        editLevel(labor);
      });
    }
  };

  const getLaborList = () => {
    dispatch(getLaborListAPI()).then((laborsList) => {
      const labors = [];
      laborsList && laborsList.forEach((labor) => {
        const costObj = _.cloneDeep(state.costObj)
        if (labor.status == "ACTIVE") {
          costObj.skill = labor.skill;
          costObj.laborId = labor.id;
          costObj.selected = true;
          costObj.averageCost = labor.cost || '';
          costObj.default_cost = labor.cost;
          // costObj.averageCostLock = true;
          labors.push(costObj);
        }
      });
      setState(prev => ({
        ...prev,
        labors
      }));
      getLevel();
    });
  };

  const inputChangeHandler = (e) => {
    if (e.target.type === "number") {
      if (parseFloat(e.target.value || 0) < 0) {
        return;
      }
    }
    const { error, valid } = ValidateField({ value: e.target.value, validation: fields[e.target.name].validation });
    setFields(prev => ({
      ...prev,
      [e.target.name]: {
        ...prev[e.target.name],
        value: e.target.value,
        touched: true,
        error: error,
        valid: valid
      },
    }));
  };

  const costChangeHandler = (e, index) => {
    let labors = _.cloneDeep(state.labors);
    if (e.target.type === "number") {
      if (parseFloat(e.target.value || 0) < 0) {
        return;
      }
    }
    if (e.target.name == "averageCost") {
      labors[index].averageCost = e.target.value;
    }
    if (e.target.name == "averageCostLock") {
      labors[index].averageCostLock = e.target.value;
      if (e.target.value === true) {
        labors[index].averageCost = labors[index].default_cost
      }
    }
    if (e.target.name == "cost") {
      labors[index].cost = e.target.value;
    }
    if (e.target.type === "checkbox") {
      labors[index].selected = e.target.checked;
    } else {
      labors[index].value = e.target.value;
      labors[index].touched = true;
      labors[index].valid = true;
      if (labors[index].selected) {
        const { error, valid } = ValidateField({ value: e.target.value, validation: [ValidatorTypes.REQUIRED] });
        labors[index].error = error;
        labors[index].valid = valid;
      }
    }
    const cost = toDecimal(labors[index].cost || 0);
    const avgCost = toDecimal(labors[index].averageCost || 0);
    labors[index].profit = cost.gt(0) ? cost.minus(avgCost).toNumber() : ''
    setState(prev => ({
      ...prev,
      labors
    }));
  };

  const editLevel = (rowData) => {
    setState(prev => ({
      ...prev,
      showList: false,
      levelId: rowData.id,
      labors: (prev.labors || []).map((labor) => {
        const data = rowData.hourlyCost && rowData.hourlyCost.find((laborCost) => labor.laborId === laborCost.id);
        if (data) {
          labor.value = data.cost;
          labor.cost = data.cost;
          labor.averageCost = data.averageCost ?? labor.averageCost;
          labor.averageCostLock = _.isBoolean(data.averageCostLock) ? data.averageCostLock : true;
        } else {
          labor.selected = false;
        }
        const cost = toDecimal(labor.cost || 0);
        const avgCost = toDecimal(labor.averageCost || 0);
        labor.profit = cost.gt(0) ? cost.minus(avgCost).toNumber() : ''
        return labor;
      }),
      edit: true,
    }));
    setFields(prev => ({
      ...prev,
      name: { ...prev.name, value: rowData.name },
      description: { ...prev.description, value: rowData.description },
      calloutCost: { ...prev.calloutCost, value: rowData.calloutCost },
      travelCost: { ...prev.travelCost, value: rowData.travelCost },
      calloutAverageCost: { ...prev.calloutAverageCost, value: rowData.calloutAverageCost },
      travelAverageCost: { ...prev.travelAverageCost, value: rowData.travelAverageCost },
    }));
  };

  const submitHandler = () => {
    const { labors, levelId } = state;
    let _fields = _.cloneDeep(fields)
    let isFormValid = true;
    for (let key in _fields) {
      const { error, valid } = ValidateField({ value: _fields[key].value, validation: _fields[key].validation });
      _fields[key].touched = true;
      _fields[key].valid = valid;
      _fields[key].error = error;
      isFormValid = isFormValid && valid;
    }
    labors.forEach((labor) => {
      if (labor.selected) {
        const { error, valid } = ValidateField({ ...labor, validation: [ValidatorTypes.REQUIRED] });
        labor.touched = true;
        labor.valid = valid;
        labor.error = error;
        isFormValid = isFormValid && valid;
      }
    });

    if (!isFormValid) {
      setFields(_fields)
      setState(prev => ({
        ...prev,
        labors
      }));
    } else {
      const data = {
        name: _fields.name.value,
        description: _fields.description.value,
        calloutCost: parseInt(_fields.calloutCost.value),
        travelCost: parseInt(_fields.travelCost.value),
        calloutAverageCost: parseInt(_fields.calloutAverageCost.value) || 0,
        travelAverageCost: parseInt(_fields.travelAverageCost.value) || 0,
      };
      if (isNaN(data.travelCost)) {
        data.travelCost = 0;
      }
      if (isNaN(data.calloutCost)) {
        data.calloutCost = 0;
      }
      const hourlyCost = [];
      labors.forEach((labor) => {
        if (labor.selected) {
          hourlyCost.push({
            id: labor.laborId,
            cost: parseFloat(labor.cost),
            skill: labor.skill,
            averageCost: labor.averageCostLock === false ? parseFloat(labor.averageCost) : null,
            averageCostLock: labor.averageCostLock,
          });
        }
      });
      data.hourlyCost = hourlyCost;
      if (!levelId) {
        dispatch(addLevel(data)).then((res) => {
          cancelHandler();
        }).catch(e => console.error(e));
      } else {
        dispatch(updateLevel(data, levelId)).then((res) => {
          cancelHandler();
        }).catch(e => console.error(e));
      }
    }
  };

  const cancelHandler = () => {
    navigate(`/${CATALOGS}/${RESOURCES}`);
  };

  return (
    <div className="purchase-order-block">
      <h2 className="content-heading text-uppercase">
        {state.edit ? "Edit Cost/Sales Level" : "Add a Cost/Sales Level"}
      </h2>
      <div className="col-12 breadcrumb-block p-0">
        <Breadcrumb>
          <Breadcrumb.Item onClick={cancelHandler}>Resource</Breadcrumb.Item>
          <Breadcrumb.Item active>
            {state.edit ? "Edit Cost/Sales Level" : "Add a Cost/Sales Level"}
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <div className="row">
        <div className="col-12 mt-3">
          <CustomInput
            {...fields.name}
            data-cy="input-name"
            onChange={(e) => inputChangeHandler(e)}
          />
        </div>

        <div className="col-12 mt-3">
          <TextAreaInput
            {...fields.description}
            data-cy="input-description"
            onChange={(e) => inputChangeHandler(e)}
          />
        </div>
      </div>

      <div className="material-list-block mt-3">
        <div className="table-responsive">
          <Table bordered className="table-create table-material table-material-ch">
            <thead>
              <tr>
                <th className="chk-width"></th>
                <th className="w-auto">Name</th>
                <th className="text-right">Default Cost / Unit</th>
                <th className="text-right">Cost / Unit Override <span className="text-danger">*</span></th>
                <th className="text-right">Charge Amount <span className="text-danger">*</span></th>
                <th className="text-right text-nowrap" style={{ minWidth: "120px" }}>Profit</th>
              </tr>
            </thead>
            <tbody>
              {(state.labors || []).map((labor, index) => {
                if (!labor) return;
                return (
                  <tr>
                    <td>
                      <Form>
                        <div className="table-checkbox">
                          <Form.Check
                            type={'checkbox'}
                            onChange={(e) => costChangeHandler(e, index)}
                            value={labor?.selected}
                            checked={labor?.selected}
                          />
                        </div>
                      </Form>
                    </td>
                    <td>{labor.skill}</td>
                    <td className="text-right">
                      {toUSD(labor.default_cost)}
                    </td>
                    <td>
                      <LockInput
                        className={'input-block-sm'}
                        lock={
                          <span className="lock-icon">
                            {idx(labor, _ => _.averageCostLock) && <LockIcon
                              onClick={(e) => costChangeHandler({ target: { name: 'averageCostLock', value: false } }, index)}
                            />}
                            {!idx(labor, _ => _.averageCostLock) && <LockOpenIcon
                              onClick={(e) => costChangeHandler({ target: { name: 'averageCostLock', value: true } }, index)}
                            />}
                          </span>
                        }
                        name="averageCost"
                        value={labor.averageCost}
                        required={true}
                        error={labor.error}
                        data-cy={`average-cost-${index}`}
                        onChange={(e) => costChangeHandler(e, index)}
                        disabled={idx(labor, _ => _.averageCostLock) ? true : false}
                      />
                    </td>
                    <td>
                      <AmountInput
                        className="input-block-sm"
                        type="number"
                        name="cost"
                        value={labor.cost}
                        required={true}
                        error={labor.error}
                        data-cy={`cost-${index}`}
                        onChange={(e) => costChangeHandler(e, index)}
                      />
                    </td>
                    <td className="text-right text-nowrap">
                      <div className="d-flex flex-column gap-1 align-items-end justify-content-center">
                        <span>{toUSD(labor.profit)}</span>
                        <span className="text-muted" style={{ fontSize: '0.85em' }}>({toPercent(labor.profit, labor.averageCost)})</span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>

      <div className="col-12 d-flex justify-content-end gap-3 mt-3">
        {writePermission && (<Button onClick={submitHandler} className="secondarybtn" id="submit-level">DONE</Button>)}
        <Button onClick={cancelHandler} className="secondarybtn cancelbtn" id="cancel-level">CANCEL</Button>
      </div>
    </div>
  );

}
